import React from 'react';
import QuickRecruitmentForm from './QuickRecruitmentForm';
export default function QuotePage(){return <QuickRecruitmentForm/>;}
